import {FormSectionType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'
import introductionField from '../fields/introductionField'
import teamNameField from '../fields/teamNameField'
import teamPhotoField from '../fields/teamPhotoField'

const sectionId: number = 1
const individualInfoSection: FormSectionType = {
	id: sectionId,
	parent_id: 0,
	channel: 'section',
	label: `${copy?.step || 'Stap'} 2`,
	fields: [
		{
			id: 0,
			parent_id: 0,
			name: 'text',
			channel: 'text',
			text:
				copy?.text?.individual ||
				'Deze inhoud zal gepubliceerd worden op je deelnemerspagina. Je kan deze later nog aanpassen indien je dit wil.'
		},
		{
			...teamNameField,
			id: 1,
			parent_id: sectionId,
			mod: 'maxwidth',
			label: copy?.teammember || 'Deelnemersnaam'
		},
		// do not use id 2 because it's automatically set in the background to set the number of team members to 1 => same as teamInfoSection 2-1-2
		{...introductionField, id: 3, parent_id: sectionId},
		{
			...teamPhotoField,
			id: 4,
			parent_id: sectionId,
			label: copy?.photo?.label || 'Foto',
			placeholder: copy?.photo?.placeholder || 'Upload foto'
		}
	]
}

export default individualInfoSection
